import { axios } from '@/services/axios';

const getAllRegions = async () => {
    const res = await axios.get('/regions/');
    return res.data;
};

export default getAllRegions;
